import React from 'react';
import './HomeFilters.css';

const quickFilters = [
  { key: 'acceptsVR', label: 'Aceita VR', emoji: '💳' },
  { key: 'goodForDate', label: 'Bom pra date', emoji: '💘' },
  { key: 'openAfterMidnight', label: 'Depois da meia-noite', emoji: '🌙' },
];

export default function HomeFilters({ filters, onChange }) {
  const toggleFilter = (key) => {
    onChange({
      ...filters,
      [key]: !filters[key]
    });
  };

  const handleSortChange = (e) => {
    onChange({
      ...filters,
      sort: e.target.value
    });
  };

  return (
    <section className="filters-card">
      <div className="filters-row">
        <span className="filters-title">Filtros rápidos</span>
        <div className="filters-chips">
          {quickFilters.map((f) => (
            <button
              key={f.key}
              type="button"
              className={'filter-chip' + (filters[f.key] ? ' on' : '')}
              onClick={() => toggleFilter(f.key)}
            >
              <span className="chip-emoji">{f.emoji}</span>
              <span className="chip-label">{f.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="filters-sort-row">
        <label className="filters-sort-label">
          Ordenar por
          <select value={filters.sort} onChange={handleSortChange}>
            <option value="top">Mais votados</option>
            <option value="new">Mais recentes</option>
          </select>
        </label>
      </div>
    </section>
  );
}
